import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

export async function getFanFeed(payload) {
  try {

    const fd = new FormData();

    fd.append("user_id", payload.user_id);
    fd.append("page_no", payload.page_no ?? 0);
    fd.append("search", payload.search || "");
    fd.append("creator", payload.creator || "");

    const res = await axios.post(
      `${apiBaseUrl}fancontentapis/get_feed`,
      fd,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    return res.data;

  } catch (err) {
    return {
      status: false,
      type: "danger",
      success: "Failed to fetch feed"
    };
  }
}

export async function getTimeline(payload) {
  try {

    const fd = new FormData();

    fd.append("user_id", payload.user_id);
    fd.append("page_no", payload.page_no ?? 0);
    fd.append("search", payload.search || "");
    fd.append("creator", payload.creator || "");

    const res = await axios.post(`${apiBaseUrl}fancontentapis/timeline`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;

  } catch (err) {
    return {
      status: false,
      type: "danger",
      success: "Timeline load failed"
    };
  }
}